import Axios from 'axios'
// import QS from 'qs'

const axios = Axios.create({
  timeout: 100000,
  baseURL: process.env.VUE_APP_BASE_API + '/'
})
// post请求加上请求头

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// 请求拦截器
axios.interceptors.request.use(
  config => {
    console.log(config)
    return config
  },
  err => {
    return Promise.resolve(err)
  }
)
// 响应拦截器
axios.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  },
  error => {
    // 有响应
    console.log('error的值：', error)
  }
)

export default axios
